export const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const currentYear = new Date().getFullYear();
export const YEARS = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];

export const EMPRESA_DEFAULT = {
  nombre: "Bremar",
  giro: "Control de plagas y saneamiento ambiental",
  licencia: "",
  licenciaVigencia: "",
};

export const NORMAS_SUGERIDAS = [
  "NOM-256-SSA1-2012 Establecimientos dedicados al servicio de control de plagas",
  "Procedimiento interno de control de plagas urbanas",
  "Personal técnico autorizado por Bremar",
];

export const ALMACEN_EMPRESA = "bremar:certificados:empresa";

export const TABS = {
  PENDIENTES: "pendientes",
  EMITIDOS: "emitidos",
};

export const CERTIFICADO_MUESTRA = {
  folio: "BR-MUESTRA-0001",
  emitidoEn: "",
  empresa: {
    nombre: EMPRESA_DEFAULT.nombre,
    giro: EMPRESA_DEFAULT.giro,
    licencia: "Licencia de muestra",
    licenciaVigencia: "Vigente",
  },
  cliente: "Cliente de muestra",
  lugar: "Inmueble de demostración",
  servicio: "Control de plagas",
  mes: "Septiembre 2026",
  fecha: "9 de septiembre de 2026",
  normas: [...NORMAS_SUGERIDAS],
  tecnico: {
    nombre: "Técnico de muestra",
    puesto: "Técnico de campo",
  },
};
